import { render, staticRenderFns } from "./RepresentativesDetailsList.vue?vue&type=template&id=137a61db&"
import script from "./RepresentativesDetailsList.vue?vue&type=script&lang=js&"
export * from "./RepresentativesDetailsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports